export const FAMILY_RELATION_TYPE = {
  CHILD: "CHILD",
  FATHER: "FATHER",
  MOTHER: "MOTHER",
  PARENT: "PARENT",
  DAUGHTER: "DAUGHTER",
  SON: "SON",
  GRANDFATHER: "GRANDFATHER",
  GRANDMOTHER: "GRANDMONTHER",
  CARER: "CARER",
  OTHER: "OTHER",
};

export const FAMILY_RELATION_LABEL = {
  [FAMILY_RELATION_TYPE.CHILD]: "Child",
  [FAMILY_RELATION_TYPE.FATHER]: "Father",
  [FAMILY_RELATION_TYPE.MOTHER]: "Mother",
  [FAMILY_RELATION_TYPE.PARENT]: "Parent",
  [FAMILY_RELATION_TYPE.DAUGHTER]: "Daughter",
  [FAMILY_RELATION_TYPE.SON]: "Son",
  [FAMILY_RELATION_TYPE.GRANDFATHER]: "Grandfather",
  [FAMILY_RELATION_TYPE.GRANDMOTHER]: "Grandmother",
  [FAMILY_RELATION_TYPE.CARER]: "Carer",
  [FAMILY_RELATION_TYPE.OTHER]: "Other",
};

export const RELATIONSHIP_OPTIONS = Object.entries(FAMILY_RELATION_LABEL).map(
  ([value, label]) => ({ value, label })
);
